import { createStandardAction } from 'typesafe-actions';

export const stopAnalyticsForNode = createStandardAction(
  'funnelState/STOP_ANALYTICS_FOR_NODE'
)<{
  nodeId: string;
}>();
